import { jsx as e, jsxs as $ } from "react/jsx-runtime";
import { useTheme as E } from "./index.es190.js";
import { Divider as T } from "./index.es24.js";
import { ColorIndicator as x } from "./index.es32.js";
import { FlexContainer as p } from "./index.es584.js";
import { BodyText as o } from "./index.es505.js";
const k = ({
  title: t,
  subtitle: l,
  testId: n,
  value: d,
  entityColor: i,
  colorIndicator: a,
  colorIndicatorProps: r
}) => /* @__PURE__ */ $(p, { testId: n, children: [
  /* @__PURE__ */ $(p, { flexGrow: 1, gap: "4px", children: [
    (!!i || a || r) && /* @__PURE__ */ e("span", { style: { paddingRight: "4px" }, children: /* @__PURE__ */ e(
      x,
      {
        testId: (r == null ? void 0 : r.testId) || `${n}-color-indicator`,
        entityColor: i,
        ...r
      }
    ) }),
    /* @__PURE__ */ e(o, { element: "p", "data-testid": `${n}-title`, variant: "bold", children: t }),
    l && /* @__PURE__ */ e(o, { "data-testid": `${n}-subtitle`, children: l })
  ] }),
  d && /* @__PURE__ */ e(o, { element: "p", "data-testid": `${n}-value`, variant: "bold", children: d })
] }), z = (t, l) => t ? "disabled" : l === "positive" ? "success" : l === "negative" ? "error" : "gray", A = ({
  value: t,
  title: l,
  entityColor: n,
  valueSuffix: d,
  testId: i,
  disabled: a,
  valueSuffixTrend: r,
  colorIndicatorProps: m,
  colorIndicator: c
}) => /* @__PURE__ */ $(p, { gap: "20px", justifyContent: "space-between", testId: i, children: [
  /* @__PURE__ */ $(p, { testId: `${i}-left-content`, gap: "8px", alignItems: "center", children: [
    (!!n || c) && /* @__PURE__ */ e("span", { style: { padding: "2px 0", height: "100%" }, children: /* @__PURE__ */ e(
      x,
      {
        testId: (m == null ? void 0 : m.testId) || `${i}-color-indicator`,
        disabled: a,
        entityColor: n,
        color: c,
        ...m
      }
    ) }),
    /* @__PURE__ */ e(
      o,
      {
        element: "p",
        variant: "regular",
        color: a ? "disabled" : void 0,
        "data-testid": `${i}-title`,
        children: l
      }
    )
  ] }),
  /* @__PURE__ */ $(p, { testId: `${i}-right-content`, gap: "4px", alignItems: "center", children: [
    /* @__PURE__ */ e(
      o,
      {
        color: a ? "disabled" : void 0,
        "data-testid": `${i}-value`,
        variant: "bold",
        element: "p",
        children: t
      }
    ),
    d && /* @__PURE__ */ e("div", { style: { width: "46px", textAlign: "end" }, children: /* @__PURE__ */ e(
      o,
      {
        "data-testid": `${i}-value-suffix`,
        variant: "semi-bold",
        size: "small",
        element: "p",
        color: z(a, r),
        children: d
      }
    ) })
  ] })
] }, t), J = ({
  testId: t,
  sections: l,
  hasDivider: n
}) => {
  const d = E();
  return /* @__PURE__ */ e(
    p,
    {
      flexDirection: "column",
      gap: "16px",
      testId: t,
      style: { backgroundColor: d.activeTheme.theme.primary.white },
      children: l.map(
        ({
          sectionItems: i,
          subtitle: a,
          title: r,
          value: m,
          entityColor: c,
          colorIndicatorProps: u,
          colorIndicator: v
        }, h) => /* @__PURE__ */ $(
          p,
          {
            testId: `${t}-${h}-wrapper`,
            gap: !r || n ? "" : "8px",
            flexDirection: "column",
            children: [
              /* @__PURE__ */ e(
                k,
                {
                  testId: `${t}-${h}-header`,
                  title: r,
                  sectionItems: i,
                  value: m,
                  subtitle: a,
                  entityColor: c,
                  colorIndicator: v,
                  colorIndicatorProps: u
                }
              ),
              !!r && n && /* @__PURE__ */ e(
                T,
                {
                  testId: `${t}-${h}-divider`,
                  margin: "4px 0"
                }
              ),
              /* @__PURE__ */ e(
                p,
                {
                  testId: `${t}-${h}-items-wrapper`,
                  flexDirection: "column",
                  gap: "2px",
                  children: i.map(
                    ({
                      value: g,
                      entityColor: y,
                      title: f,
                      valueSuffix: C,
                      valueSuffixTrend: b,
                      disabled: w,
                      colorIndicator: D,
                      colorIndicatorProps: j
                    }, s) => /* @__PURE__ */ e(
                      A,
                      {
                        testId: `${t}-${h}-item-${s}`,
                        value: g,
                        title: f,
                        disabled: w,
                        entityColor: y,
                        valueSuffixTrend: b,
                        valueSuffix: C,
                        colorIndicator: D,
                        colorIndicatorProps: j
                      },
                      `${f}-${g}-${s}`
                    )
                  )
                }
              )
            ]
          },
          `${r}-${m}-${h}`
        )
      )
    }
  );
};
export {
  J as EntityDetailsTooltipContent
};
//# sourceMappingURL=index.es131.js.map
